/**
 * Mirrors the server's `InterviewProcessingState` value for value. Only types front tables keyed by
 * state: the label always comes from the API, as `{ value, label }` on `InterviewView.processingState`.
 */
export enum InterviewProcessingState {
	UPLOADING = 'uploading',
	AWAITING_CHOICE = 'awaiting_choice',
	NO_WORKFLOW = 'no_workflow',
	NO_RECORDING = 'no_recording',
	RUNNING = 'running',
	STALLED = 'stalled',
	FAILED = 'failed',
	PARTIAL = 'partial',
	SUCCEEDED = 'succeeded',
	HANDLED = 'handled',
}

const STATES: readonly InterviewProcessingState[] = Object.values(InterviewProcessingState);

/** The enum member a server value names, or `null` for a value this front does not know yet. */
export const parseInterviewProcessingState = (value: string): InterviewProcessingState | null =>
	STATES.find((state) => state === value) ?? null;
